import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getId,
  createItem,
  updateItem,
  deleteById,
  getGenerate,
  updateSequenceItem,
  getExport,
} from "./settingJourneyAPI";

const initialState = {
  data: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchData = createAsyncThunk(
  "settingJourney/fetchData",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);
export const fetchSettingJourney = createAsyncThunk(
  "settingJourney/fetchSettingJourney",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchGenerate = createAsyncThunk(
  "settingJourney/fetchGenerate",
  async (payload) => {
    const response = await getGenerate(payload);
    return response;
  }
);

export const fetchId = createAsyncThunk(
  "settingJourney/fetchId",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);

export const fetchIdNoloading = createAsyncThunk(
  "settingJourney/fetchIdNoloading",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);

export const addItem = createAsyncThunk(
  "settingJourney/addItem",
  async (payload) => {
    const response = await createItem(payload);
    return response;
  }
);

export const editItem = createAsyncThunk(
  "settingJourney/editItem",
  async (payload) => {
    const response = await updateItem(payload);
    return response;
  }
);

export const editSequenceItem = createAsyncThunk(
  "settingJourney/editSequenceItem",
  async (payload) => {
    const response = await updateSequenceItem(payload);
    return response;
  }
);

export const removeById = createAsyncThunk(
  "settingJourney/removeById",
  async (payload) => {
    const response = await deleteById(payload);
    return response;
  }
);
export const fetchExport = createAsyncThunk(
  "settingJourney/fetchExport",
  async (payload) => {
    const response = await getExport(payload);
    return response;
  }
);
export const settingJourneySlice = createSlice({
  name: "settingJourney",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchSettingJourney.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSettingJourney.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })

      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editSequenceItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editSequenceItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchGenerate.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchGenerate.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchExport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchExport.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = settingJourneySlice.actions;

export const selectData = (state) => state.settingJourney.data;
export const selectId = (state) => state.settingJourney.dataId;
export const selectLoading = (state) => state.settingJourney.loading;
export const selectError = (state) => state.settingJourney.error;
export const selectPageNo = (state) => state.settingJourney.pageNo;
export const selectPageSize = (state) => state.settingJourney.pageSize;
export const selectTotalRecord = (state) => state.settingJourney.totalRecord;
export const selectSelected = (state) => state.settingJourney.selected;
export const selectResult = (state) => state.settingJourney.result;

export default settingJourneySlice.reducer;
